import { auth } from "./firebase";

export function getApiUrl(path: string) {
  const host =
    process.env.NODE_ENV !== "production"
      ? "http://localhost:5000"
      : "https://codeapprove.com";

  return `${host}${path}`;
}

async function authHeader(): Promise<string> {
  const token = await auth().currentUser?.getIdToken();
  return token ? `Bearer ${token}` : "";
}

export async function get(
  path: string,
  options?: {
    headers?: {
      "x-codeapprove-github-token"?: string;
    };
  }
) {
  const url = getApiUrl(path);

  const res = await fetch(url, {
    method: "GET",
    mode: "cors",
    headers: new Headers({
      Authorization: await authHeader(),
      ...(options?.headers || {})
    })
  });

  return await res.json();
}

export async function post(path: string, body?: unknown) {
  const url = getApiUrl(path);
  const headers = new Headers({
    Authorization: await authHeader()
  });
  if (body !== undefined) {
    headers.set("Content-Type", "application/json");
  }

  const res = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined
  });

  return await res.json();
}
